import React from "react";
import "./book-mark.scss";
import EasyButton from "./easy-button";
import { FaArrowLeft } from "react-icons/fa";
import "./arrow-button.scss";

interface ArrowButtonProps {
    onClick?: Function;
}

export const ArrowButton = (props: ArrowButtonProps) => {
    return (
        <div className="arrow-button-content">
            <EasyButton
                title={"GERİ"}
                onClick={props.onClick}
                buttonIcon={<FaArrowLeft style={{ marginRight: 10 }} size={20} />}
                className="arrow-button"
            />
        </div>
    )
}